export default "__VITE_ASSET__81630a21__"